import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _regeneratorRuntime from "@babel/runtime/regenerator";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React, { Component, Fragment } from 'react';
import { Link } from 'react-router-dom';
import { Button, Card, Checkbox, Flex, Tabs, Tab, Icon, translate } from '@haldor/ui';
import { connect } from 'react-redux';
import { Spinner, Expandable } from 'UI';
import DateTime from '_class/DateTime';
import User from '_class/User';
import { getDescription } from 'helpers/content';
import { getAllUserSections } from 'actions/user';

var SectionList = /*#__PURE__*/function (_Component) {
  _inherits(SectionList, _Component);

  var _super = _createSuper(SectionList);

  function SectionList(props) {
    var _this;

    _classCallCheck(this, SectionList);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "componentDidMount", function () {
      _this.getSections();
    });

    _defineProperty(_assertThisInitialized(_this), "getFilter", function () {
      var filter = '';

      if (_this.state.filters.includes('mentor')) {
        filter += 'MENTOR_GROUP;';
      }

      if (_this.state.filters.includes('education')) {
        filter += 'EDUCATION_GROUP;';
      }

      if (_this.state.filters.includes('groups_owned_by_me')) {
        filter += 'OWNED_BY_ME;';
      }

      if (!_this.state.filters.includes('archived')) {
        filter += 'ACTIVE;';
      }

      return filter;
    });

    _defineProperty(_assertThisInitialized(_this), "getSections", function () {
      _this.setState({
        loading: true
      });

      var filter = _this.getFilter();

      if (_this.state.user.isAdministrator()) {
        _this.props.getAllUserSections(_this.props.userId, {
          pageIndex: _this.state.page,
          filter: filter,
          sortBy: _this.state.sort
        }).then(function () {
          _this.setState({
            loading: false
          });
        });
      }
    });

    _defineProperty(_assertThisInitialized(_this), "getNextPage", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return _this.setState({
                page: _this.state.page + 1
              });

            case 2:
              _this.getSections();

            case 3:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    })));

    _defineProperty(_assertThisInitialized(_this), "noGroupsFound", function () {
      return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("h3", {
        style: {
          textAlign: 'center'
        }
      }, _this.props.translate('no-sections-found')));
    });

    _defineProperty(_assertThisInitialized(_this), "cutDescription", function (description) {
      if (description == null) {
        return '';
      }

      var strippedDescription = getDescription(description).replace(/(<([^>]+)>)/ig, '');

      if (strippedDescription.length > 99) {
        return strippedDescription.slice(0, 100) + '…';
      }

      return strippedDescription;
    });

    _defineProperty(_assertThisInitialized(_this), "toggleFilter", /*#__PURE__*/function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(filter) {
        var filters;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                filters = _this.state.filters;

                if (filters.includes(filter)) {
                  filters = filters.filter(function (f) {
                    return f != filter;
                  });
                } else {
                  filters.push(filter);
                }

                _context2.next = 4;
                return _this.setState({
                  filters: filters,
                  page: 1
                }, function () {
                  localStorage.setItem('staff-group-filters', JSON.stringify(_this.state.filters));
                });

              case 4:
                _this.getSections();

              case 5:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));

      return function (_x) {
        return _ref2.apply(this, arguments);
      };
    }());

    _defineProperty(_assertThisInitialized(_this), "renderGroupResult", function () {
      var _groups;

      var groups = _this.props.groups;

      var filter = _this.getFilter();

      var showResult = filter.includes('MENTOR_GROUP') || filter.includes('EDUCATION_GROUP') || filter.includes('UNLINKED');
      groups = (_groups = groups) === null || _groups === void 0 ? void 0 : _groups.filter(function (el) {
        return el.id != 0;
      });
      return /*#__PURE__*/React.createElement("div", null, !_this.state.loading && groups != null && groups.length == 0 || !showResult ? _this.noGroupsFound() : null, groups != null && groups.length > 0 && showResult ? groups.map(_this.renderGroup) : null);
    });

    _defineProperty(_assertThisInitialized(_this), "renderGroup", function (group, index) {
      var user = new User(_this.props.currentUser);
      var loading = _this.state.loadingGroups.indexOf(group.id) > -1;
      var events = group.events;
      var element = Link;

      if (group.id == 0) {
        element = null;
      }

      if (_this.state.filters == null || _this.state.filters.length == 0) {
        return null;
      }

      if (events != null) {
        events = events.filter(function (e) {
          return e.event == 'Group connected' || e.event == 'Group archived' || e.event == 'Group recovered from archiving';
        });
      }

      var cardTitle = /*#__PURE__*/React.createElement("div", {
        className: "group-header"
      }, /*#__PURE__*/React.createElement("span", {
        className: "header-title"
      }, group.title), !user.isStudent() ? group.id != 0 ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
        className: "card-meta outline",
        style: {
          marginLeft: '.75rem',
          borderColor: '#19db6c'
        }
      }, _this.props.translate('Connected')), group.lastSynced != null ? /*#__PURE__*/React.createElement("div", {
        className: "card-meta",
        style: {
          marginLeft: '.75rem'
        }
      }, /*#__PURE__*/React.createElement(Icon, {
        name: "Sync"
      }), "".concat(new DateTime(group.lastSynced).getDateStamp(), ", ").concat(new DateTime(group.lastSynced).getTime())) : null) : /*#__PURE__*/React.createElement("div", {
        className: "card-meta outline",
        style: {
          marginLeft: '.75rem',
          borderColor: '#efc24c'
        }
      }, _this.props.translate('Not connected')) : null, group.archived ? /*#__PURE__*/React.createElement("div", {
        className: "card-meta",
        style: {
          marginLeft: '.75rem'
        }
      }, _this.props.translate('Archived')) : null);
      return /*#__PURE__*/React.createElement(Card, {
        element: element,
        to: "/groups/".concat(group.id),
        style: {
          marginBottom: '0.75rem'
        },
        key: 'group-' + group.id + '-' + index
      }, /*#__PURE__*/React.createElement("div", {
        style: {
          flex: 1
        }
      }, /*#__PURE__*/React.createElement(Expandable, {
        title: cardTitle,
        open: _this.state.expand
      }, /*#__PURE__*/React.createElement(Flex, {
        top: true,
        space: true
      }, /*#__PURE__*/React.createElement("div", {
        className: "description size-14"
      }, _this.cutDescription(group.description)), !user.isStudent() ? /*#__PURE__*/React.createElement("div", {
        className: "size-14"
      }, events != null ? events.map(function (event, index) {
        return /*#__PURE__*/React.createElement(Flex, {
          key: index
        }, /*#__PURE__*/React.createElement("div", {
          className: "event-date"
        }, new DateTime(event.created).getDateStamp()), /*#__PURE__*/React.createElement("div", {
          className: "event-text"
        }, _this.props.translate(event.event) + ' ' + event.createdBy.firstName + ' ' + event.createdBy.lastName));
      }) : null) : null)), !user.isStudent() ? /*#__PURE__*/React.createElement("div", {
        className: "meta-container",
        style: {
          marginTop: '.5rem'
        }
      }, group.type != null ? /*#__PURE__*/React.createElement("div", {
        className: "card-meta",
        style: {
          marginRight: '.75rem'
        }
      }, _this.props.translate(group.type)) : null, group.userRole == 'OWNER' ? /*#__PURE__*/React.createElement("div", {
        className: "card-meta",
        style: {
          marginRight: '.75rem'
        }
      }, _this.props.translate('Owner')) : /*#__PURE__*/React.createElement("div", {
        className: "card-meta",
        style: {
          marginRight: '.75rem'
        }
      }, _this.props.translate('Member'))) : null));
    });

    _defineProperty(_assertThisInitialized(_this), "toggleExpand", function () {
      return _this.setState({
        expand: !_this.state.expand
      });
    });

    _defineProperty(_assertThisInitialized(_this), "renderFoldButton", function () {
      return /*#__PURE__*/React.createElement(Flex, {
        end: true
      }, /*#__PURE__*/React.createElement("div", {
        className: "all-fold-button color--meta ".concat(_this.state.expand ? 'open' : 'closed'),
        onClick: _this.toggleExpand
      }, /*#__PURE__*/React.createElement(Icon, {
        name: "ArrowLeft"
      }), _this.state.expand ? _this.props.translate('Hide description') : _this.props.translate('Show description')));
    });

    _defineProperty(_assertThisInitialized(_this), "renderFilters", function () {
      var user = new User(_this.props.currentUser);
      return /*#__PURE__*/React.createElement("div", {
        className: "filter-container"
      }, /*#__PURE__*/React.createElement("div", {
        className: "form"
      }, /*#__PURE__*/React.createElement("div", {
        className: "form-row"
      }, /*#__PURE__*/React.createElement("div", {
        className: "form-row-half last"
      }, /*#__PURE__*/React.createElement("div", {
        style: {
          marginTop: '1rem',
          "float": 'right'
        }
      }, /*#__PURE__*/React.createElement(Fragment, null, /*#__PURE__*/React.createElement(Checkbox, {
        label: _this.props.translate('Education groups'),
        value: _this.state.filters.indexOf('education') > -1,
        onChange: function onChange() {
          return _this.toggleFilter('education');
        }
      }), /*#__PURE__*/React.createElement(Checkbox, {
        label: _this.props.translate('Mentor groups'),
        value: _this.state.filters.indexOf('mentor') > -1,
        onChange: function onChange() {
          return _this.toggleFilter('mentor');
        }
      })), _this.state.filters.indexOf('mentor') > -1 || _this.state.filters.indexOf('education') > -1 ? /*#__PURE__*/React.createElement(Checkbox, {
        label: _this.props.translate('Show archived'),
        value: _this.state.filters.indexOf('archived') > -1,
        onChange: function onChange() {
          return _this.toggleFilter('archived');
        }
      }) : null)), /*#__PURE__*/React.createElement("div", {
        className: "clearfix"
      }))));
    });

    _defineProperty(_assertThisInitialized(_this), "renderGroupList", function () {
      return /*#__PURE__*/React.createElement("div", null, _this.state.loading ? /*#__PURE__*/React.createElement(Spinner, {
        center: true
      }) : /*#__PURE__*/React.createElement(React.Fragment, null, _this.renderFoldButton(), _this.renderGroupResult()));
    });

    var _filters = ['education', 'archived'];
    var sort = 'TITLE';

    var _user = new User(props.currentUser);

    if (localStorage.getItem('staff-group-filters') != null) {
      _filters = JSON.parse(localStorage.getItem('staff-group-filters'));
    }

    _this.state = {
      expand: false,
      loading: false,
      selectedGroup: null,
      loadingGroups: [],
      page: 1,
      sort: sort,
      filters: _filters,
      user: _user
    };
    return _this;
  }

  _createClass(SectionList, [{
    key: "render",
    value: function render() {
      var _this$props$groups, _this$props$groups2;

      var user = new User(this.props.currentUser);
      var filter = this.getFilter();
      var showResult = filter.length > 0;
      return /*#__PURE__*/React.createElement("div", {
        className: "page groups"
      }, !user.isStudent() ? this.renderFilters() : null, this.renderGroupList(), this.state.searchQuery == null && ((_this$props$groups = this.props.groups) === null || _this$props$groups === void 0 ? void 0 : _this$props$groups.length) % 20 < 1 && ((_this$props$groups2 = this.props.groups) === null || _this$props$groups2 === void 0 ? void 0 : _this$props$groups2.length) > 0 && this.state.filters.length > 0 && showResult ? /*#__PURE__*/React.createElement("div", {
        className: "df jcc",
        style: {
          marginTop: '2rem'
        }
      }, /*#__PURE__*/React.createElement(Button, {
        type: "secondary",
        onClick: this.getNextPage
      }, this.state.loading ? /*#__PURE__*/React.createElement(Spinner, null) : null, this.props.translate('Show more'))) : null);
    }
  }]);

  return SectionList;
}(Component);

function mapStateToProps(state) {
  return {
    translate: translate(state.Languages.translations),
    currentUser: state.user.currentUser,
    groups: state.user.userSections
  };
}

export default connect(mapStateToProps, {
  getAllUserSections: getAllUserSections
})(SectionList);